import { Pipe, PipeTransform } from "@angular/core";
import { AvatarSize } from "types/interfaces";

@Pipe({
  name: "convertAvatarToUserIconSize",
  standalone: true,
})
export class ConvertAvatarToUserIconSizePipe implements PipeTransform {
  transform(value: AvatarSize): string {
    switch (value) {
      case "x-mini-no-border":
      case "x-mini":
        return "db-icon-lg"; // 16px for 28px avatar container
      case "micro":
      case "micro-no-border":
      case "mini":
      case "mini-no-border":
      case "x-micro-no-border":
        return "db-icon-xl"; // 24px for 32px/36px avatar container
      case "standard":
      case "standard-no-border":
        return "db-icon-2xl"; // 32px for 52px/56px avatar container
      case "x-large-no-border":
        return "db-icon-4xl"; // 64px for 112px avatar container
      default:
        return "db-icon-xl"; // Default to 24px
    }
  }
}
